import React from 'react';
import {
  createGame,
  DEFAULT_CONFIG,
  type StumbleHomeState,
  type StumbleHomeConfig,
} from '../../../games/stumble-home/stumble-home';
import type { RoomView } from '../../../types/room';

interface Props {
  slug: string;
  room: RoomView;
  myId: string;
  isLeader: boolean;
  initialState: StumbleHomeState | null;
  onFinish: () => void;
}

export default function StumbleHomeRoomGame({ onFinish }: Props) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white gap-6 p-8">
      <h1 className="text-4xl font-bold">Stumble Home</h1>
      <p className="text-gray-400 max-w-md text-center leading-relaxed">
        Silent cooperative 3-player trick-taker on a triangular grid.
        This game is currently in design — use the map maker to create and test maps.
      </p>
      <div className="flex gap-4">
        <a
          href="/stumble-home/map-maker"
          target="_blank"
          rel="noopener noreferrer"
          className="px-6 py-3 bg-cyan-600 hover:bg-cyan-500 rounded-lg font-medium transition-colors"
        >
          Open Map Maker
        </a>
        <button
          onClick={onFinish}
          className="px-6 py-3 bg-gray-600 hover:bg-gray-500 rounded-lg font-medium transition-colors"
        >
          End Session
        </button>
      </div>
    </div>
  );
}

export { createGame as createStumbleHomeGame, DEFAULT_CONFIG as STUMBLE_HOME_DEFAULT_CONFIG };
export type { StumbleHomeState, StumbleHomeConfig };
